import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

import GooglePlayButton from "./../../components/GooglePlayButton";
import AppleButton from "./../../components/AppleButton";
export default function DownloadApp() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <section className="bg-[#FDEEEC] mt-24">
      <div className="  px-8  py-10 md:px-0 md:py-0  md:flex md:items-center md:justify-between">
        <div className="relative -mt-24  md:mb-0 md:mr-16">
          <img
            alt="Person using smartphone"
            className="hidden md:block md:w-[800px] md:h-[700px] md:object-cover"
            height="50"
            src="image/home/wepik-export-20240225042018UCO9 1.png"
            style={{
              aspectRatio: "400/400",
              objectFit: "cover",
            }}
            width="200"
          />
        </div>
        <div className="" data-aos="fade-up">
          <h2 className="text-4xl font-bold mb-4">Download the app</h2>
          <p className="mb-16">
            Have a personal driver at your fingertips no matter where you are
            with our easy-to-use smartphone app.
          </p>
          <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
            <AppleButton />
            <GooglePlayButton />
          </div>
        </div>
        <div className="justify-end md:mt-0">
          <img
            alt="Smartphone app screenshot"
            className="hidden md:block md:w-[800px] md:h-auto md:object-cover"
            height="50"
            src="image/home/app1.png"
            style={{
              aspectRatio: "400/400",
              objectFit: "cover",
            }}
            width="200"
          />
        </div>
      </div>
    </section>
  );
}

function AppleIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z" />
      <path d="M10 2c1 .5 2 2 2 5" />
    </svg>
  );
}

function PlayIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  );
}
